module.exports = __webpack_public_path__ + "static/artist-management-hero-mobile-bc49f9ddd89448fbdbb0648291fae0a2.webp";